import React from "react";
import { createPortal } from "react-dom";
import styles from "./WithdrawalModal.module.css";
import Withdrawal from "../../../assets/Icons/withdrawal.svg?react";

export default function WithdrawalModal({
  isOpen,
  isClosing,
  onClose,
  onConfirm,
  balanceUSDT,
}) {
  if (!isOpen) return null;

  const modalContent = (
    <div className={`${styles.modalWrapper}`}>
      <div className={`${styles.modal} ${isClosing ? styles.slideDown : ""}`}>
        <div className={styles.modalContent}>
          <button className={styles.closeButton} onClick={onClose}></button>

          <div className={styles.imagePlaceholder}>
            <Withdrawal />
          </div>
          <div className={styles.rewardsModal}>
            <p className={styles.rewardText}>
              Ты собираешься вывести
              <br />
              <strong>{balanceUSDT.toFixed(4)} USDT</strong>
            </p>
            <p className={styles.rewardText_warning}>
              *Ваш запрос на вывод будет обработан в порядке очереди.
            </p>
          </div>

          <button className={styles.subscribeButton} onClick={onConfirm}>
            Подтвердить вывод
          </button>
          <button className={styles.cancelButton} onClick={onClose}>
            Отмена
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
}
